<template>
  <div style="margin-top: 10px">

    <el-form :model="formData" :rules="rules">
      <el-row>
        <el-col :span="11">
          <el-form-item label="设备编号：" label-width="120px" prop="star1">
            <el-input disabled v-model="formData.device_no"  placeholder="设备编号" clearable style="width: 250px"></el-input>
          </el-form-item>
          <el-form-item label="资产编号：" label-width="120px" prop="star1">
            <el-input v-model="formData.asset_no"  placeholder="资产编号" clearable style="width: 250px"></el-input>
          </el-form-item>
          <el-form-item label="设备名称：" label-width="120px" prop="star1">
            <el-input v-model="formData.name"  placeholder="设备名称" clearable style="width: 250px"></el-input>
          </el-form-item>
          <el-form-item label="设备类型：" label-width="120px" prop="star1">
            <el-select v-model="formData.type_id"   placeholder="设备类型" clearable style="width: 250px">
              <el-option v-for="dict in eqDeviceTypeAll" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格型号：" label-width="120px">
            <el-input v-model="formData.model"  placeholder="规格型号" clearable style="width: 250px"></el-input>
          </el-form-item>
          <el-form-item label="部门：" label-width="120px">
            <el-select v-model="formData.department"  placeholder="部门" clearable style="width: 250px">
              <el-option v-for="dict in departmentList" :key="dict.value" :label="dict.name" :value="dict.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用人：" label-width="120px">
            <el-input v-model="formData.use_user_name"  placeholder="使用人" clearable style="width: 250px"></el-input>
          </el-form-item>
          <el-form-item label="使用地点：" label-width="120px">
            <el-input v-model="formData.use_place"  placeholder="使用地点" clearable style="width: 250px"></el-input>
          </el-form-item>
        </el-col>

        <el-col style="margin-left: 50px" :span="11">
          <el-form-item>
            <span style="margin-bottom: 8px">二维码标签 ：</span>
<!--            <el-button style="margin-bottom: 8px" @click="printPreview1" :loading="loading">预览80*80</el-button>-->
            <el-button style="margin-bottom: 8px;background-color: yellow" @click="printPreview2" :loading="loading">预览90*80</el-button>
<!--            <el-button style="margin-bottom: 8px" @click="print1" :loading="loading">打印80*80</el-button>-->
            <el-button style="margin-bottom: 8px" type="primary" @click="print2" :loading="loading">打印90*80</el-button>
            <KfMessage ref="commitMessage"></KfMessage>
          </el-form-item>
          <el-form-item v-if="this.view1">
            <div id="divPrint" v-for="item in this.printImages" :key="item.imageBase64">
              <img class="preview-img" :src="item.imageBase64" :style="'width:' + imageWidth1 + 'px; height:' + imageHeight1 + 'px;'"
                   v-if="item.imageBase64.length > 0">
            </div>
          </el-form-item>
          <el-form-item v-if="this.view2">
            <div id="divPrint" v-for="item in this.printImages" :key="item.imageBase64">
              <img class="preview-img" :src="item.imageBase64" :style="'width:' + imageWidth2 + 'px; height:' + imageHeight2 + 'px;'"
                   v-if="item.imageBase64.length > 0">
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="业务内容：" label-width="120px">
        <el-input v-model="formData.business_content" type="textarea"  placeholder="业务内容" clearable style="width: 600px"></el-input>
      </el-form-item>
      <el-form-item label="备注：" label-width="120px">
        <el-input v-model="formData.remark" type="textarea"  placeholder="备注" clearable style="width: 600px"></el-input>
      </el-form-item>
      <el-form-item label="设备图片：" label-width="120px">
        <FrameItem v-model="formData.device_image_ids" :file-list="formData.image_ids" ref="image_upload" name="选择文件" :item="device_image_ids"></FrameItem>
      </el-form-item>
      <el-form-item label="设备资料：" label-width="120px">
        <frame-item v-model="formData.device_file_ids" :file-list="formData.device_ids" ref="file_upload" name="选择文件" :item="device_file_ids"></frame-item>
      </el-form-item>
      <el-form-item label="ISO文件：" label-width="120px">
        <el-input v-model="formData.iso_sn"  placeholder="请输入ISO文件编号" clearable style="width: 250px"></el-input>
      </el-form-item>
      <el-form-item label="结构图：" label-width="120px">
        <FrameItem v-model="formData.structure_image_ids" :file-list="formData.structure_ids" ref="image_upload" name="选择文件" :item="structure_image_ids"></FrameItem>
      </el-form-item>
      <el-form-item label="安全操作规范：" label-width="120px">
        <FrameItem v-model="formData.safe_operation_file_ids" :file-list="formData.safe_operation_ids" ref="file_upload" name="选择文件" :item="safe_operation_file_ids"></FrameItem>
      </el-form-item>
      <el-form-item label="设备操作手册：" label-width="120px">
        <FrameItem v-model="formData.device_operation_file_ids" :file-list="formData.device_operation_ids" ref="file_upload" name="选择文件" :item="device_operation_file_ids"></FrameItem>
      </el-form-item>
      <el-form-item label="故障排查手册：" label-width="120px">
        <FrameItem v-model="formData.troubleshooting_file_ids" :file-list="formData.troubleshooting_ids" ref="file_upload" name="选择文件" :item="troubleshooting_file_ids"></FrameItem>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="width: 100px;margin-top: 20px;margin-left: 45%" @click="updateDeviceData" :loading="submitLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

export default {
  name: "EqDeviceListZhiZaoEdit",
  inject:['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
      },
      rules: {
        star1: [{required: true, message: '', trigger: 'red'}],
      },
      device_image_ids: {
        component: 'image_upload',
        limit: 100
      },
      device_file_ids: {
        component: 'file_upload',
        show_success_cnt: true,
        show_total_cnt: true,
        limit: 100
      },
      iso_file_ids: {
        component: 'file_upload',
        show_success_cnt: true,
        show_total_cnt: true,
        limit: 100
      },
      structure_image_ids: {
        component: 'image_upload',
        limit: 100
      },
      safe_operation_file_ids: {
        component: 'file_upload',
        show_success_cnt: true,
        show_total_cnt: true,
        limit: 100
      },
      device_operation_file_ids: {
        component: 'file_upload',
        show_success_cnt: true,
        show_total_cnt: true,
        limit: 100
      },
      troubleshooting_file_ids: {
        component: 'file_upload',
        show_success_cnt: true,
        show_total_cnt: true,
        limit: 100
      },
      eqDeviceTypeAll: [],
      loading: false,
      submitLoading: false,
      sawBladeList:[],
      imageHeight1: 270,
      imageWidth1: 270,
      imageHeight2: 270,
      imageWidth2: 305,
      view1: false,
      view2: false,
      printDto: {},
      printImages:[],
      printDtoList:[]
    }
  },
  computed: {
    departmentList() {
      return this.$store.getters['core/getDictList']('device_department');
    },
  },
  methods:{

    async getEqDeviceTypeAll() {
      await this.$http('eqDsZhiZaoService.getEqDeviceTypeAll',{}, false).then(data => {
        this.eqDeviceTypeAll = data
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    },

    async updateDeviceData() {
      this.submitLoading = true;
      if (!this.formData.device_no){
        this.submitLoading = false
        return this.$message.error(`设备编号不能为空`);
      }
      if (!this.formData.asset_no){
        this.submitLoading = false
        return this.$message.error(`资产编码不能为空`);
      }
      if (!this.formData.name){
        this.submitLoading = false
        return this.$message.error(`设备名称不能为空`);
      }
      if (!this.formData.type_id){
        this.submitLoading = false
        return this.$message.error(`设备类型不能为空`);
      }

      await this.$http('eqDeviceZhiZaoService.updateDeviceData',this.formData).then(data => {
        this.submitLoading = false
        this.$fn.search();
        this.$fn.closeWindow()
        return this.$message.success('提交成功!');
      }, errMsg => {
        this.submitLoading = false
        return this.$message.error(errMsg);
      })
    },


    async getDeviceData() {
      await this.$http('eqDeviceZhiZaoService.getDeviceData',this.parentData).then(data => {
        this.formData = data
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    },

    async printPreview1() {
      this.loading = true;
      this.printImages = []
      await this.$http('eqDeviceZhiZaoService.getDeviceTmplLabel1',this.formData, false).then(data => {
        this.loading = false;
        this.printDtoList = data

        for (let i = 0; i < this.printDtoList.length; i++) {
          let printDto = JSON.parse(JSON.stringify(this.printDtoList[i]))
          if (printDto.image_base64.length > 0) {
            printDto.image_base64 = "data:image/jpeg;base64," + printDto.image_base64;
          }
          this.printImages.push(printDto)
        }
        this.view1 = true
        this.view2 = false
      }, errMsg => {
        this.loading = false;
        this.$refs.commitMessage.showError(`生成打印图像失败，${errMsg}`);
      })
    },

    async print1() {
      await this.printPreview1();
      this.loading = false;
      // this.printDiv()
      // 调用本地打印服务器
      // var printParams = {printer_name: this.printDto.printerName, zpl: this.printDto.zpl};
      for (let i = 0; i < this.printDtoList.length; i++) {
        console.log(this.printDtoList[i])
        this.$axios.post(process.env.VUE_APP_PRINT_URL, this.printDtoList[i]).then(response => {
          this.loading = false;
          let res = response.data
          console.log(res)
        }, error => {
          this.loading = false;
          console.log(`提交打印失败，${error.message}`)
          this.$message.error('连接打印机失败，请检查打印机状态。');
        })
      }
    },


    async printPreview2() {
      this.loading = true;
      this.printImages = []

      await this.$http('eqDeviceZhiZaoService.getDeviceTmplLabel2',this.formData, false).then(data => {
        this.loading = false;
        this.printDtoList = data


        for (let i = 0; i < this.printDtoList.length; i++) {
          let printDto = JSON.parse(JSON.stringify(this.printDtoList[i]))
          if (printDto.image_base64.length > 0) {
            printDto.image_base64 = "data:image/jpeg;base64," + printDto.image_base64;
          }
          this.printImages.push(printDto)
        }
        this.view1 = true
        this.view2 = false
      }, errMsg => {
        this.loading = false;
        this.$refs.commitMessage.showError(`生成打印图像失败，${errMsg}`);
      })
    },


    async print2() {
      await this.printPreview2();
      this.loading = false;
      // this.printDiv()
      // 调用本地打印服务器
      // var printParams = {printer_name: this.printDto.printerName, zpl: this.printDto.zpl};
      for (let i = 0; i < this.printDtoList.length; i++) {
        console.log(this.printDtoList[i])
        this.$axios.post(process.env.VUE_APP_PRINT_URL, this.printDtoList[i]).then(response => {
          this.loading = false;
          let res = response.data
          console.log(res)
        }, error => {
          this.loading = false;
          console.log(`提交打印失败，${error.message}`)
          this.$message.error('连接打印机失败，请检查打印机状态。');
        })
      }
    },


    printDiv() {
      //打印div
      //打开一个新窗口newWindow
      var newWindow = window.open("打印窗口", "_blank");
      //要打印的div的内容
      var docStr = document.getElementById("divPrint").innerHTML;
      //打印内容写入newWindow文档
      newWindow.document.write(docStr);
      //关闭文档
      newWindow.document.close();

      //调用打印机
      setTimeout(() => {
        newWindow.print();
        newWindow.close();
      }, 50);

      return false;
    },



  },
  created() {
    this.getEqDeviceTypeAll()
    this.getDeviceData()
  }
}
</script>

<style scoped>
.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
  width: 650px;
  margin-left: 80px
}
.close {
  position: absolute;
  top: 5px;
  margin-left: -40px;
  font-size: 18px;
  cursor: pointer;
}
.row {
  margin-left: 80px;
  width: 650px;
  margin-top: 10px;
  height: 35px;
  line-height: 35px;
  text-align: center;
}
</style>